<div *ngIf="user">
  <h4><p class="text-center">Nieuwe gebruiker</p></h4>

  <div class="card">
    <div class="card-block">
      <pre *ngIf="error">{{error}}</pre>
      <div class="form-group row">
        <label class="col-form-label col-3">Naam</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="user.name" type="text"></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Email</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="user.email" type="text"></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Rechten</label>
        <div class="col-9"><p-dropdown [options]="userRoles" [(ngModel)]="user.role"></p-dropdown></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Wachtwoord</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="password" type="text"></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Wachtwoord herhaling</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="passwordRepeat" type="text"></div>
      </div>
    </div>
  </div>
</div>

<div class="row ui-toolbar">
  <div class="col-md-6">
    <button type="button" class="btn btn-primary" (click)="saveUser()">
      Opslaan
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      Annuleren
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/admin/users/add/users.add.component.html